export default function allUsersFiltrationFunction({ dispatchParams }) {
  const {
    paginationData = null,
    departmentNames = null,
    genderNames = null,
    employeTypeName = null,
    employeStatus = null,
    wingNames = null,
    reportingHeadNames = null,
    leaveName = null,
    presentNames = null,
    fromDate = null,
    toDate = null,
    selectedFoodStatus = null,
  } = dispatchParams;
  let departmentFilter = 'filters[department]=equals:';
  let genderFilter = 'filters[sex]=equals:';
  let employeFilter = 'filters[EmploymentType]=equals:';
  let employeStatusFilter = 'filters[status]=equals:';
  let wingFilter = 'filters[wingName]=equals:';
  let reportHeadFilter = 'filters[reportingHead]=equals:';
  let leaveFilter = 'filters[leaveStatus]=equals:';
  let attendenceFilter = 'filters[AttendanceStatus]=equals:';

  if (departmentNames?.length > 0) {
    departmentFilter += departmentNames.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (genderNames?.length > 0) {
    genderFilter += genderNames.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (employeTypeName?.length > 0) {
    employeFilter += employeTypeName.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (employeStatus?.length > 0) {
    employeStatusFilter += employeStatus.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (wingNames?.length > 0) {
    wingFilter += wingNames.map((dName) => `${encodeURIComponent(dName)}`).join(encodeURIComponent('+'));
  }
  if (reportingHeadNames?.length > 0) {
    reportHeadFilter += reportingHeadNames.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (leaveName?.length > 0) {
    leaveFilter += leaveName.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  if (presentNames?.length > 0) {
    attendenceFilter += presentNames.map((dName) => `${dName}`).join(encodeURIComponent('+'));
  }
  const url = `users/all-users/?page=${paginationData?.pageNum}&limit=${
    paginationData?.gridSize
  }&search=${paginationData?.search ? encodeURIComponent(paginationData?.search) : ''}${departmentNames?.length > 0 ? `&${departmentFilter}` : ''}${genderNames?.length > 0 ? `&${genderFilter}` : ''}${employeTypeName?.length > 0 ? `&${employeFilter}` : ''}${employeStatus?.length > 0 ? `&${employeStatusFilter}` : ''}${wingNames?.length > 0 ? `&${wingFilter}` : ''}${reportingHeadNames?.length > 0 ? `&${reportHeadFilter}` : ''}${leaveName?.length > 0 ? `&${leaveFilter}` : ''}${presentNames?.length > 0 ? `&${attendenceFilter}` : ''}${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}${`&foodStatus=${selectedFoodStatus}`}`;
  return url;
}
